import { GradingObject, PartialResponse, } from "../../interfaces";

export function checkForMatches(data: GradingObject, matchingFunction: Function, spellCorrected=false): PartialResponse|null {
  const gen = matchingFunction(data, spellCorrected);
  let next = gen.next();
  while (true) {
    if (next.value || next.done) {
      break;
    }
    next = gen.next();
  }
  if (next.value) {
    // Return a deep copy to prevent mutations to the original response object
    return JSON.parse(JSON.stringify(next.value));
  }
}
